// ─────────────────────────────────────────────────────────────────────────────
// "vs last month" UNDER A KPI — AND THE CASE WHERE THERE ISN'T ONE.
//
// ⚠️ THE BASELINE IS "HOW MANY EXISTED AT THE END OF LAST MONTH", counted from
// created_at on the same rows the headline uses. It is NOT a snapshot of past
// state: a partner who was active last month and is archived today is absent
// from both numbers, so the delta understates churn rather than inventing it.
//
// 🚨 SOME FACTS HAVE NO HONEST BASELINE, AND THIS RENDERS NOTHING FOR THEM.
// Whether an account could be paid last month is not recorded anywhere — banking,
// payee contact and license verification are current state with no history — so a
// "vs last month" under Needs Attention would be a fabricated trend wearing the
// same styling as three measured ones. Pass `prev={null}` and the row is omitted;
// callers with no baseline get a `note` instead.
import React from 'react';

export default function KpiDelta({ value, prev, note }) {
  if (note) {
    return (
      <div style={{ marginTop: 8, fontSize: 11, color: '#9ca3af', lineHeight: 1.4 }}>{note}</div>
    );
  }
  // ⚠️ null/undefined MEANS "NO BASELINE" AND RENDERS NOTHING. Zero is a real
  // baseline and must not be treated as absent — going 0 → 5 is the most
  // interesting month a firm can have.
  if (prev === null || prev === undefined) return null;

  const diff = (Number(value) || 0) - (Number(prev) || 0);
  if (diff === 0) {
    return <div style={{ marginTop: 8, fontSize: 11, color: '#9ca3af' }}>No change vs last month</div>;
  }
  const up = diff > 0;
  return (
    <div style={{ marginTop: 8, fontSize: 11, color: up ? '#15803d' : '#b91c1c', fontWeight: 600 }}>
      {up ? '▲' : '▼'} {Math.abs(diff)}
      <span style={{ color: '#9ca3af', fontWeight: 400 }}> vs last month</span>
    </div>
  );
}
